module.exports = __webpack_public_path__ + "static/media/scooter.fecd099f.png";